export default "__VITE_ASSET__zprvOfhW__"